import { render } from "./showResult.vue?vue&type=template&id=4da45643&scoped=true"
import script from "./showResult.vue?vue&type=script&lang=js"
export * from "./showResult.vue?vue&type=script&lang=js"

import "./showResult.vue?vue&type=style&index=0&id=4da45643&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4da45643"]])

export default __exports__